export const environment = {
  production: false,
  staging: false,
  dev: false,
  siteUrl: 'https://myportal-sandbox.business.comcast.com',
  apiUrl: 'https://myportal-sandbox.business.comcast.com/api/v2',
  mocks: false,
  iscUrl: 'https://isc.staging.masergy.com?kc_idp_hint=comcast-idbroker',
  awsMapApiKey: "v1.public.eyJqdGkiOiJjNzAyZmI5Yi00NzIzLTQ1ZjItYWFmOC04ODU1M2EwODczNWIifVIH0wml674QZOOwCqXdF7mXLFdSwf_MIcEixMmPke0KIYJRpOS6GuyuqHT8MmCMWW5IKBXN2O4nIXbD1gIWbG_roDsG2ddNdu8fcU-4X1A78Fh_5U8Pmnkzdt1TVMtohI1JDoTT53KovGUp-9ZyW4p4iW3Ams1yozAQcC_0TUBoU1ygjo7WeBJXrxXFJA9JhRbxD_MgnJgUXs8lrog-9wZ68ZIV0XkkundJvlHABNJY7R-B7ZdF4iv_VqLjRVoJkR8bHxPiIzXRHI3E4H3FkDkCbJyDyYxsppTKIKzaVFieG-FyDqxrOA_w6CX4LyFL2O36uc-u4Ym-TFONav8Uw4U.MGFjMDA4ZmUtYWRiYy00NTgyLTg0Y2MtZTY3MzFlZDRmYTQ1",
  awsMapRegion: 'us-west-2',
  oktaClientId: '0oa2dri9y2z2whs8B0h8',
  oktaIssuer:
    'https://login-dev.business.comcast.com/oauth2/auspfww55tWNlx5O20h7',
};
